
export let cardStyle = {
  width: '780px',
  maxWidth: '100%',
  margin: '0 auto',
  boxShadow:
    '0 13px 35px -12px rgba(0, 0, 0, 0.56), 0 1px 22px 0px rgba(0, 0, 0, 0.12), 0 5px 7px -5px rgba(0, 0, 0, 0.2)'
};

/* Top Section */

export let cardHeaderStyle = {
  marginBottom: '0.8rem',
  fontSize: '14px',
  textAlign: 'center'
};

export let cardTitleStyle = {
  fontSize: '28px',
  fontWeight: '400'
};

/* Middle Section */

export let cardContentStyle = {
  width: '640px',
  maxWidth: '100%',
  paddingTop: '0',
  margin: '0 auto'
};

/* Bottom Section */

export let cardFooterStyle = {
  marginBottom: '0.5rem',
  fontSize: '14px',
  textAlign: 'center'
};

export let linkStyle = {
  color: '#319bd5',
  textDecoration: 'none'
};

export let errorStyle = {
  color: '#dc3545',
  textAlign: 'center'
};

